/**
 * Styles for wf-select component (Shadow DOM)
 */

import { css } from 'lit';

import { formInputBaseStyles } from './base/form-input-base.styles.js';

export const wfSelectStyles = [
  formInputBaseStyles,
  css`
    :host {
      position: relative;
    }

    .wf-select-trigger {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-height: var(--wf-input-min-height);
      padding: var(--wf-spacing-4);
      font-size: var(--wf-font-size-base);
      font-weight: var(--wf-font-weight-input);
      font-family: inherit;
      background: var(--wf-glass-bg);
      backdrop-filter: blur(var(--wf-glass-blur));
      -webkit-backdrop-filter: blur(var(--wf-glass-blur));
      border: 1px solid var(--wf-glass-border);
      border-radius: var(--wf-radius-md);
      box-shadow: var(--wf-glass-shadow);
      color: var(--wf-color-text);
      transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
      outline: none;
      box-sizing: border-box;
      cursor: pointer;
      text-align: left;
    }

    .wf-select-trigger:focus {
      border-color: var(--wf-color-primary);
      box-shadow: 0 0 0 var(--wf-focus-ring-width) var(--wf-focus-ring-primary);
    }

    .wf-select-trigger:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .wf-select-trigger.wf-select-error {
      border-color: var(--wf-color-error);
    }

    .wf-select-trigger.wf-select-error:focus {
      box-shadow: 0 0 0 var(--wf-focus-ring-width) var(--wf-focus-ring-error);
    }

    .wf-select-placeholder {
      color: var(--wf-color-text-muted);
      font-weight: var(--wf-font-weight-input);
    }

    .wf-select-chevron {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-left: var(--wf-spacing-2);
      color: var(--wf-color-text-muted);
      transition: transform 150ms ease;
    }

    .wf-select-chevron.wf-open {
      transform: rotate(180deg);
    }

    /* Dropdown panel */
    .wf-select-panel {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      z-index: 100;
      margin-top: var(--wf-spacing-1);
      padding: var(--wf-spacing-1) 0;
      background: var(--wf-color-text);
      border-radius: var(--wf-radius-md);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      max-height: 240px;
      overflow-x: hidden;
      overflow-y: auto;
      opacity: 0;
      transform: translateY(-4px);
      transition: opacity 150ms ease, transform 150ms ease;
      pointer-events: none;
    }

    .wf-select-panel.wf-open {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    .wf-select-option {
      display: block;
      width: 100%;
      padding: var(--wf-spacing-3) var(--wf-spacing-4);
      font-size: var(--wf-font-size-base);
      font-family: inherit;
      color: white;
      background: transparent;
      border: none;
      cursor: pointer;
      text-align: left;
      outline: none;
      transition: background 100ms ease;
      word-wrap: break-word;
      overflow-wrap: break-word;
      box-sizing: border-box;
    }

    .wf-select-option:hover,
    .wf-select-option.wf-active {
      background: rgba(255, 255, 255, 0.1);
    }

    .wf-select-option.wf-selected {
      background: rgba(255, 255, 255, 0.15);
    }

    /* Hidden slot for slotted <option> elements */
    .wf-options-slot {
      display: none;
    }
  `,
];
